import { CompensationLineSave } from "@/types/employees/employee-compensation.types.ts";

export type CompensationLineChange = "added" | "removed" | "changed";

export interface CompensationLineDiff {
  id: number | string;
  change: CompensationLineChange;
  line: CompensationLineSave;
}

const comparableLine = (line: CompensationLineSave) => {
  const comparable = { ...line };
  delete comparable.id;
  return comparable;
};

export const diffCompensationLines = (
  previous: CompensationLineSave[],
  next: CompensationLineSave[]
): CompensationLineDiff[] => {
  const previousById = new Map(previous.filter((line) => line.id).map((line) => [line.id, line]));
  const nextById = new Map(next.filter((line) => line.id).map((line) => [line.id, line]));
  const result: CompensationLineDiff[] = [];

  next.forEach((line, index) => {
    if (!line.id) {
      result.push({ id: `new-${index}`, change: "added", line });
      return;
    }
    const oldLine = previousById.get(line.id);
    if (
      oldLine &&
      JSON.stringify(comparableLine(oldLine)) !== JSON.stringify(comparableLine(line))
    ) {
      result.push({ id: line.id, change: "changed", line });
    }
  });
  previous.forEach((line) => {
    if (line.id && !nextById.has(line.id)) result.push({ id: line.id, change: "removed", line });
  });

  return result;
};
